//  filepath: src/utils/number.js
export const toDollars = (cents) => Number(cents ?? 0) / 100;
export const fmtUSD = (cents) =>
  `$${toDollars(cents).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
export const fmtUSDMaybe = (v) => (v == null ? "—" : fmtUSD(v));
export const fmtIntMaybe = (v) =>
  v == null ? "—" : Number(v).toLocaleString("en-US");

const toDollarsRounded = (cents) => Math.round(Number(cents ?? 0) / 100);
export const fmtUSDWhole = (cents) =>
  `$${toDollarsRounded(cents).toLocaleString("en-US")}`;

export const compactUSDWhole = (cents) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
    notation: "compact",
  }).format(toDollarsRounded(cents));
